import { useEffect, useMemo } from "react";
import { useGLTF } from "@react-three/drei";
import { RigidBody } from "@react-three/rapier";
import * as THREE from "three";

export default function ChessBishop({
  position = [0, 0, 0],
  rotation = [0, 0, 0],
  scale = 1,
  colliders = "trimesh",
  type = "fixed",
  ...rigidBodyProps
}) {
  const { scene } = useGLTF("/Chess Piece/PrimaryWhiteBishop_001.glb");
  const bishopScene = useMemo(() => scene.clone(true), [scene]);

  useEffect(() => {
    bishopScene.traverse((child) => {
      if (child instanceof THREE.Mesh || child instanceof THREE.SkinnedMesh) {
        child.castShadow = true;
        child.receiveShadow = true;
      }
    });
  }, [bishopScene]);

  return (
    <RigidBody
      type={type}
      colliders={colliders}
      position={position}
      rotation={rotation}
      {...rigidBodyProps}
    >
      <group scale={scale}>
        <primitive object={bishopScene} />
      </group>
    </RigidBody>
  );
}

useGLTF.preload("/Chess Piece/PrimaryWhiteBishop_001.glb");
